module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_suns@3x-d75f090e352b2103fd2e1ff0e3f87eea.webp";